import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyFinances = lazy(() => import('./Finances'));

export const Finances: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyFinances {...props} />
	</Suspense>
);
